import { useAppSelector } from 'store/hooks';
import { SettingSelectors } from 'store/Settings';
import { UserSelectors } from 'store/User';

export const useBadgeSectionDisplaySettings = (props?: {
  ignoreDeviceSetting?: boolean;
}) => {
  const { ignoreDeviceSetting } = props ?? {};

  const interfaceSettingsFeatureFlag = useAppSelector(
    UserSelectors.selectInterfaceSettings,
  );

  const {
    shouldDisplayDriverDetails: _shouldDisplayDriverDetails,
    shouldDisplayOrderChannel: _shouldDisplayOrderChannel,
    shouldDisplayOrderType: _shouldDisplayOrderType,
  } = useAppSelector(SettingSelectors.selectOrderHeaderInterfaceSettings);

  return {
    shouldDisplayDriverDetails:
      (_shouldDisplayDriverDetails || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.order_header.driver_details,
    shouldDisplayOrderChannel:
      (_shouldDisplayOrderChannel || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.order_header.order_channel,
    shouldDisplayOrderType:
      (_shouldDisplayOrderType || ignoreDeviceSetting) &&
      interfaceSettingsFeatureFlag.order_header.order_type,
  };
};
